/* eslint-disable @nice-cxone/ccf/required-tsdoc */
import { WebsocketClient } from '../lib/ws/websocket-client';
import { WSWorker } from '../lib/worker/ws-worker'; // Adjust the import path as needed
import { WsReconnectResponse } from '../lib/ws/model/ws-reconnect-response';
import { WsReconnectInfo } from '../lib/ws/model/ws-reconnect-info';

export class LiveVoiceWSClient extends WebsocketClient {
  private wsWorker: WSWorker;

  constructor() {
    super();
    this.wsWorker = new WSWorker();
  }

  public onMessage(msg: any): void {
    console.log('WebSocket message received:', msg);
    // Handle the message
  }

  public onError(): void {
    console.error('WebSocket error');
  }

  public onClosed(): void {
    console.log('WebSocket disconnected');
  }

  public onOpen(): void {
    console.log('WebSocket connected successfully');
  }

  protected onReconnect(msg?: WsReconnectResponse): void {
    console.log('WebSocket reconnecting...', msg);
  }

  protected onReconnectComplete(): void {
    console.log('WebSocket reconnect complete');
  }

  connect(websocketUrl: string): void {
    this.wsWorker.connect(websocketUrl, this.checkWSEvent.bind(this));
  }

  attemptReconnect(reconnectInfo: WsReconnectInfo): void {
    this.wsWorker.attemptReconnect(reconnectInfo, this.checkWSEvent.bind(this));
  }

  sendMessage(msg: unknown): void {
    this.wsWorker.send(msg);
  }
}